<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <!-- Data Peserta -->
  <CCardBody>
    <CRow>
      <div class="col-sm-12 col-xl-2">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Periode</label>
          <multiselect
            class="multi-select"
            label="labelPeriode"
            placeholder="Pilih Periode"
            :show-labels="false"
            required
            v-model="periode"
            @select="changePeriode"
            :options="dataTahun"
          ></multiselect>
        </div>
      </div>
      <div class="col-sm-12 col-xl-4">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Kategori Pelatihan</label>
          <multiselect
            class="multi-select"
            placeholder="Pilih Kategori Pelatihan"
            v-model="kategoriPelatihan"
            :options="options"
            @select="changeKategoriPelatihan"
            :show-labels="false"
          ></multiselect>
        </div>
      </div>      
      <div class="col-sm-12 col-xl-6">
        <div class="form-group">
          <label for="" class="font-weight-bold">Pilih Pelatihan</label>
          <multiselect
            class="multi-select"
            placeholder="Pilih pelatihan"
            id="pelatihanSelect"
            :show-labels="false"
            required
            v-model="pelatihan"
            @select="changeSertifikasi"
            :options="dataPelatihan"
            :custom-label="customLabel"
          >
            <template slot="option"  slot-scope="{ option }">{{ option.no_laporppl ? option.no_laporppl + ' - ' : '' }} {{ option.nama_pelatihan ? option.nama_pelatihan : '' }}</template>
          </multiselect>
        </div>
      </div>

      <div class="col-sm-12 col-xl-12">
        <div style="float: left">
          <template v-if="role_status && role_status.status_export_excel">
          <button class="btn btn-info" @click="download">
            Download Data Pembayaran
          </button>
          </template>
        </div>
        <div style="float: right">          
          <button class="btn btn-info mr-2" @click="resetFilter" >
            Reset Filter
          </button>
          <button class="btn btn-success" @click="changePelatihan">
            Terapkan Filter
          </button>
        </div>
      </div>
    </CRow>
  </CCardBody>
  <!-- End Data Peserta -->
</template>

<script>
import PeriodeService from "@/services/datamaster/periode-rpl.service";
import PaymentService from "@/services/finance/payment.service";
import WorkshopService from "@/services/pelatihan/workshop.service";
import dataPesertaLmsService from '@/services/pelatihan/data-peserta/data-peserta-lms.service';
import { AlertUtils } from "@/mixins/AlertUtils";
import { Pagination } from "@/mixins/Pagination";
import { KategoriAnggota } from "@/mixins/master/KategoriAnggota";
import { exportUtils } from '@/mixins/exportUtils';

export default {
  mixins: [AlertUtils, Pagination, KategoriAnggota, AlertUtils],  
  data() {
    return {
      kategoriPelatihan: "",
      options: ['Pelatihan LMS', 'Pelatihan Webinar', 'Pelatihan Offline'],
      formFilter: {
        periode: "",
        value: "",
        kategori_pelatihan : '',
        id_workshop_pelatihan: "",        
        tipe: 'pembayaran_pelatihan',
      },
      pelatihan: "",
      periode: "",
      kategori_anggota: "",
      dataSertifikasi: [],
      items: [],
      dataPelatihan: [],
      dataTahun: [],
      details: [],
      status: false,
      myModal: false,
      modalDetail: false,
      modalDetailPeserta: false,
      disabledKategoriPelatihan: true,
      disabledPelatihan: true,
      horizontal: { label: "col-3", input: "col-9" },
      collapseDuration: 0,
      content: [],
      role_status: null
    };
  },

  mounted() {
    this.roleData();
    this.getPeriode();
  },

  computed: {
    years () {
      const year = new Date().getFullYear()
      return Array.from({length: year - 2017}, (value, index) => 2018 + index)
    }
  },

  methods: {
     roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/keuangan/pembayaran' );  
      this.role_status = data;
    },
    customLabel({no_laporppl, nama_pelatihan}) {
      return `${no_laporppl ? no_laporppl + ' - ' : ''} ${nama_pelatihan ? nama_pelatihan : ''}`
    },

    changeSertifikasi(value) {
      this.formFilter.id_workshop_pelatihan = value.id_workshop_pelatihan;
    },

    filterData() {
      this.$parent.filterData(this.formFilter);
    },

    resetFilter() {
      this.kategoriPelatihan = "";
      this.periode = "";
      this.id_workshop_pelatihan = "";
      $("#filterStatusPembayaran").val("");
    },    

    getPelatihan(value) {
      var vm = this;
      var kategori = value;
      if(kategori == "Pelatihan Webinar") {
        WorkshopService.getWebinar(0,1000000,'default','default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content;
          vm.dataPelatihan.id_workshop_pelatihan = this.dataPelatihan[0].id_workshop_pelatihan
          var data = {
            nama_pelatihan : "Semua",
            id_workshop_pelatihan : "default"
          }
          this.dataPelatihan.unshift(data);
          
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "Pelatihan Offline") {
        WorkshopService.getWorkshop(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data.data.content; 
          vm.dataPelatihan.id_workshop_pelatihan = this.dataPelatihan[0].id_workshop_pelatihan
          var data = {
            nama_pelatihan : "Semua",
            id_workshop_pelatihan : "default"
          }
          this.dataPelatihan.unshift(data);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      } else if(kategori == "Pelatihan LMS") {
        dataPesertaLmsService.getPelatihan(0,1000000,'default')
        .then((response) => {
          vm.dataPelatihan = response.data;
          vm.dataPelatihan.nama_pelatihan = response.data.title;
          var data = {
            nama_pelatihan : "Semua",
            id_workshop_pelatihan : "default"
          }
            this.dataPelatihan.unshift(data);
        })
        .catch((error) => {
          // comment console console.log(error);
        });
      }      
    },

    getPeriode() {
      if (localStorage.getItem('formFilterPelatihan')) {
        var filter = JSON.parse(localStorage.getItem('formFilterPelatihan'));
        this.formFilter = filter.formFilter;
        this.kategoriPelatihan = filter.kategoriPelatihan
        this.periode = filter.periode;
        this.pelatihan = filter.pelatihan;
        this.getPelatihan();
        this.changePelatihan()
      }
      const year = new Date().getFullYear()
      for (let index = 0; index < 3; index++) {
        this.dataTahun.push(
          {
            labelPeriode: year - index,
            value: year - index,
          }
        );
      }
    },

    changePelatihan() {
      var filter = {
        formFilter: this.formFilter,
        kategoriPelatihan: this.kategoriPelatihan,
        periode: this.periode,
        pelatihan: this.pelatihan,
      }
      localStorage.setItem('formFilterPelatihan', JSON.stringify(filter))
      var value = {
        id : this.formFilter.id_workshop_pelatihan,
        periode : this.formFilter.periode,
        tipe : this.formFilter.tipe,
        kategoriPelatihan : this.kategoriPelatihan
      }
      this.$parent.changePelatihan(value);
    },

    changePeriode(value) {  
      this.formFilter.periode = value.value
      this.disabledKategoriPelatihan = false
    },

    changeKategoriPelatihan(value) {
      this.formFilter.kategori_pelatihan = value
      this.disabledPelatihan = false
      this.getPelatihan(value);
    },

    download(value) {
      var value = {
        id : this.formFilter.id_workshop_pelatihan,
        periode : this.formFilter.periode,
        kategori_pelatihan : this.formFilter.kategori_pelatihan
      }
      this.$parent.download(value);
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
